export default __webpack_public_path__ + "static/media/LENS_CULINARIS_SIRE_fragment_6.dc98b956.jpg";